import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const getApiData = async (tcrid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");

  const response = await axios.get(`
    ${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getAPIData&tcrid=${tcrid}`);

  return response.data;
};

const useGetApiDataQuery = (tcrid) => {
  return useQuery({
    queryKey: ["getApiData", tcrid],
    queryFn: () => getApiData(tcrid),
  });
};

export default useGetApiDataQuery;
